import { useEffect, useRef } from 'react';
import { useMap } from 'react-leaflet';
import { useData } from '../contexts/DataContext';

export default function MapAutoCenter() {
  const { latest } = useData();
  const map = useMap();
  const hasCenteredRef = useRef(false); // track whether we've centered

  useEffect(() => {
    if (!hasCenteredRef.current && latest?.lat && latest?.lon) {
      map.setView([latest.lat, latest.lon], map.getZoom(), {
        animate: true
      });
      hasCenteredRef.current = true; // only center once
    }
  }, [latest, map]);

  return null;
}
